// i18n area 'tasks' — locale hu-HU (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.hu-HU.meta.json.
import type { enUS } from './tasks'

export const huHU: typeof enUS = {
  macrotasks: {
    title: 'Makrofeladatok',
    subtitle: 'Összetett műveletek — a sikertelen lépéstől folytathatók, vagy félbeszakíthatók',
    colType: 'Típus',
    colTarget: 'Objektum',
    colPhase: 'Fázis',
    colSteps: 'Lépések',
    empty: 'Nincs makrofeladat',
    detail: 'Részletek',
    failedAt: 'elbukott ennél:',
    resume: 'Újrapróbálás a sikertelen lépéstől',
    abort: 'Teljes félbeszakítás',
    cancel: 'Megszakítás',
    actionError: 'A rendszer elutasította a műveletet'
  },
  tasks: {
    title: 'Feladatok',
    searchPlaceholder: 'Keresés típus vagy cél szerint',
    type: 'Típus',
    target: 'Cél',
    phaseLabel: 'Fázis',
    progress: 'Előrehaladás',
    started: 'Elindult',
    finished: 'Befejeződött',
    node: 'Csomópont',
    empty: 'Nincs feladat',
    loadError: 'A feladatok nem tölthetők be — elérhető a TVirt backend?',
    limboHint: "A(z) '{node}' csomópont {time} óta elérhetetlen — a feladat addig tartja a write lease-t a célján, amíg a csomópont vissza nem tér, vagy kikapcsoltnak nem nyilvánítják",
    nodeAttested: 'Csomópont kikapcsoltnak nyilvánítva',
    phase: {
      queued: 'Sorban áll',
      running: 'Fut',
      succeeded: 'Sikeres',
      failed: 'Sikertelen',
      cancelled: 'Megszakítva',
      'failed-at-step': 'Lépésnél elbukott',
      aborted: 'Félbeszakítva'
    },
    dropdown: {
      tooltip: 'Futó feladatok',
      title: 'Futó feladatok',
      empty: 'Nincs folyamatban lévő feladat',
      viewAll: 'Összes feladat megtekintése'
    },
    detail: {
      open: 'Részletek',
      scope: 'Hatókör',
      message: 'Üzenet',
      params: 'Paraméterek',
      result: 'Eredmény',
      errorTitle: 'Hiba',
      steps: 'Lépések',
      failedAt: 'elbukott ennél:',
      superseded: 'leváltva',

      // Dialog standard (round #156): il posto del figlio nel piano del padre,
      // il padre stesso (apribile in-place) e il passo colpevole.
      step: 'Lépés',
      parent: 'Szülőfeladat',
      failedStep: 'Sikertelen lépés',
      log: 'Napló',
      logEmpty: 'Még nincs naplóbejegyzés',
      close: 'Bezárás'
    },
    actions: {
      cancel: 'Megszakítás',
      resume: 'Újrapróbálás a sikertelen lépéstől',
      abort: 'Teljes félbeszakítás (a kész lépések visszavonása)',
      refused: 'A rendszer elutasította a műveletet'
    }
  },
  events: {
    loadError: 'A napló betöltése nem sikerült — elérhető a TVirt backend?',
    title: 'Események',
    subtitle: 'A fürt történeti emlékezete: megtörtént tények, a legújabbtól',
    filterSeverity: 'Súlyosság',
    filterCategory: 'Kategória',
    filterAll: 'Mind',
    searchLabel: 'Keresés',
    searchPlaceholder: 'Keresés a teljes naplóban',
    subjectFilter: '{subject} eseményei — mind megjelenítése',
    colAt: 'Mikor',
    colSeverity: 'Súlyosság',
    colType: 'Típus',
    colSubject: 'Tárgy',
    colActor: 'Ki',
    colNode: 'Node',
    colMessage: 'Üzenet',
    empty: 'Nincs esemény',
    loadMore: 'Továbbiak betöltése',
    actorSystem: 'rendszer',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'Esemény azonosító',
    taskCollectedHint: 'A task megőrzése rövidebb: begyűjtés után a hivatkozás már nem válaszol',
    severity: {
      info: 'Információ',
      warning: 'Figyelmeztetés',
      error: 'Hiba',
      critical: 'Kritikus'
    },
    category: {
      lifecycle: 'Életciklus',
      config: 'Konfiguráció',
      availability: 'Rendelkezésre állás',
      security: 'Biztonság'
    },
    type: {
      haNetsvcFailedOver: 'Hálózati szolgáltatás failovere',
      haNetsvcNoCandidate: 'Hálózati szolgáltatás jelölt csomópont nélkül',
      haNetsvcReaped: 'Helyi példány learatva a visszatéréskor',
      netsvcFloatipMoved: 'A lebegő IP másik birtokoshoz vándorolt',
      netsvcFloatipNoHolder: 'Lebegő IP egészséges cél nélkül',
      haAppFailedOver: 'App-példány failover',
      haAppNoCandidate: 'App-példány jelölt csomópont nélkül',
      haAppStorageLocalSkip: 'App-példány nem került át: a tartós adatok a halott csomóponton helyiek',
      haAppReaped: 'Az App-példány helyi podja visszatéréskor learatva'
    }
  },
  audit: {
    loadError: 'Az auditnapló nem tölthető be — elérhető a TVirt backend?',
    title: 'Audit',
    subtitle: 'Ki mit tett, mikor, melyik objektumon — megkísérelt műveletek, az elutasításokkal együtt',
    filterOutcome: 'Kimenet',
    filterAll: 'Mind',
    filterSudo: 'Csak emelt jogú műveletek',
    colAt: 'Mikor',
    colActor: 'Ki',
    colAction: 'Művelet',
    colTarget: 'Objektum',
    colOutcome: 'Kimenet',
    colNode: 'Node',
    empty: 'Nincs rögzített művelet',
    loadMore: 'Továbbiak betöltése',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Útvonal',
    detailProblem: 'Ok',
    detailTask: 'Task',
    detailClientIp: 'Honnan',
    detailId: 'Rekordazonosító',
    detailSession: 'Munkamenet',
    taskHint: 'Egy elfogadott művelet kimenete az eseménynaplóban él, ugyanezen task-azonosító alatt',
    outcome: {
      succeeded: 'Sikerült',
      accepted: 'Elfogadva',
      denied: 'Megtagadva',
      rejected: 'Elutasítva',
      failed: 'Meghiúsult'
    }
  },
  notifications: {
    loadError: 'Az értesítések betöltése nem sikerült — elérhető a TVirt backend?',
    actionError: 'A rendszer elutasította a műveletet',
    title: 'Értesítések',
    subtitle: 'A célok, amelyek felé a napló tényei elhagyják a fürtöt',
    rulesTitle: 'Szabályok',
    rulesSubtitle: 'Mely tények mennek ki, és hová',
    deliveriesTitle: 'Kézbesítések',
    deliveriesSubtitle: 'Minden értesítés eredménye, az okkal, ha meghiúsul',
    colName: 'Név',
    colKind: 'Típus',
    colWhere: 'Hová',
    colScope: 'Scope',
    colSeverity: 'Súlyosság',
    colMatch: 'Szűrő',
    colTargets: 'Cél',
    colAt: 'Mikor',
    colState: 'Állapot',
    colEvent: 'Esemény',
    colAttempts: 'Kísérletek',
    colOutcome: 'Eredmény',
    empty: 'Nincs sor',
    matchAll: 'minden tény',
    test: 'Próba',
    testOk: 'Próbaértesítés kézbesítve ide: {target}',
    testFailed: 'A(z) {target} felé küldött próba meghiúsult: {reason}',
    retry: 'Sorba vissza',
    retried: 'A kézbesítés visszakerült a sorba',
    grouped: 'és további {count} ismétlés',
    state: {
      failed: 'Sikertelen',
      pending: 'Sorban áll',
      sending: 'Küldés folyamatban',
      sent: 'Elküldve'
    },
    tabTargets: 'Célok',
    tabRules: 'Szabályok',
    tabDeliveries: 'Kiszállítások',
    targetCreateTitle: 'Új cél',
    ruleCreateTitle: 'Új szabály',
    nameHint: 'Kisbetűk, számok és kötőjelek; hatókörönként egyedi',
    kindImmutableHint: 'Nem módosítható: a típus megváltoztatása új cél létrehozását jelenti',
    kindSmtp: 'Levél (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Állapot',
    enabledOn: 'Aktív',
    enabledOff: 'Felfüggesztve',
    smtpHost: 'SMTP-kiszolgáló',
    smtpPort: 'Port',
    smtpPortHint: 'Szokásos: 25 TLS nélkül, 587 starttls-sel, 465 tls-sel',
    smtpSecurity: 'Biztonság',
    smtpFrom: 'Feladó',
    smtpTo: 'Címzettek',
    smtpToHint: 'Egy vagy több, vesszővel elválasztott cím',
    webhookUrl: 'URL',
    payload: 'Tartalom',
    payloadHint: 'A minimal esetén az esemény üzenete és adatai nem hagyják el a fürtöt',
    credential: 'Hitelesítő adat',
    credentialNone: 'Nincs',
    credentialHintSmtp: 'A relay fiókja a kulcstárból; nincs esetén anonim SMTP',
    credentialHintWebhook: 'Aláírási titok a kulcstárból; aláírás nélkül bárki, aki ismeri az URL-t, a fürtnek adhatja ki magát',
    minSeverityHint: 'Küszöb, nem halmaz: ettől a súlyosságtól felfelé',
    categories: 'Kategóriák',
    categoriesHint: 'Üres = mind',
    types: 'Eseménytípusok',
    typesHint: 'Vesszővel elválasztva; üres = mind. Az ismeretlen típus elutasításra kerül',
    targetsHint: 'Legalább egy; a szabály hatókörében vagy annak egyik felmenőjében kell lennie',
    recursiveOn: 'A gyermek hatókörök is',
    recursiveOff: 'Csak ez a hatókör',
    recursiveHint: 'Az erőforrások a levelekben élnek: gyermekek nélkül a gyökéren lévő szabály szinte semmiről nem értesít',
    repeatWindow: 'Csoportosítási ablak (s)',
    repeatWindowHint: 'Az ablakon belül az ismétlések nem küldenek levelet: az elsőnél számolódnak. A 0 kikapcsolja',
    targetInUseError: 'A(z) {name} célt még használja egy szabály'
  }
}
